import { combineReducers } from 'redux';

import {
    SURVEYS_LOADING,
    SURVEYS_LOADED,
    SURVEY_LOADING,
    SURVEY_LOADED,
    ANSWERS_LOADED,
    SURVEY_COMPANY_LOADING,
    SURVEY_COMPANY_LOADED,
} from 'modules/surveys/actions/survey.action';

import { AUTH_LOGOUT } from 'modules/auth/actions/authentication.action';

export const loadingSurveys = (state = false, action) => {
    switch (action.type) {
        case SURVEYS_LOADING:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const surveys = (state = null, action) => {
    switch (action.type) {
        case SURVEYS_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export const loadingSurvey = (state = false, action) => {
    switch (action.type) {
        case SURVEY_LOADING:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export const survey = (state = { options: [] }, action) => {
    switch (action.type) {
        case SURVEY_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export const answers = (state = null, action) => {
    switch (action.type) {
        case ANSWERS_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
}

export const surveyCompany = (state = null, action) => {
    switch (action.type) {
        case SURVEY_COMPANY_LOADED:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export const loadingSurveyCompany = (state = true, action) => {
    switch (action.type) {
        case SURVEY_COMPANY_LOADING:
            return action.payload;
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    loadingSurveys,
    surveys,
    loadingSurvey,
    survey,
    answers,
    loadingSurveyCompany,
    surveyCompany
});
